var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"aiflow-empty"},[_c('div',{staticClass:"aiflow-empty__icon"}),_c('p',{staticClass:"aiflow-empty__content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }